module.exports = __webpack_public_path__ + "website/img/je-group.f5b180cc.svg";